import $ from "jquery";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const update_auto_spin_speed = function() {
  const disabled = ($('#variant_auto_spin_for').val() === "") || ($('#variant_auto_spin_for').val() === "0");
  const opacity = disabled ? 0.2 : 1;
  // $('#variant_auto_spin').prop('disabled', disabled)
  return $('.hide-if-autospin-off').css({opacity});
};

$(function() {
  
  // Load edit form on click
  $(document).on("click", ".edit-variant", () => update_auto_spin_speed());
  
  return $(document).on('change', '#variant_auto_spin_for', () => update_auto_spin_speed());
});